var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1746429862326,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 14465,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.088 959.104a32 32 0 0 1-32-32A445.76 445.76 0 0 1 337.92 515.52a443.008 443.008 0 0 1 173.888-35.136 447.36 447.36 0 0 1 136.512 21.184 32 32 0 0 1-19.52 60.864 383.168 383.168 0 0 0-499.584 364.544 32.256 32.256 0 0 1-32.128 32.128zM511.68 473.6a204.8 204.8 0 0 1-204.032-192.576 203.2 203.2 0 0 1 51.392-147.84 204.608 204.608 0 0 1 356.928 124.16 204.608 204.608 0 0 1-192.32 216c-3.968 0.128-7.936 0.256-11.968 0.256zM503.68 128.832a139.328 139.328 0 0 0-96.768 46.848 139.52 139.52 0 0 0-35.328 101.632c4.48 77.312 71.104 136.576 148.416 132.096s136.64-71.104 132.096-148.416A140.672 140.672 0 0 0 503.68 128.832z",
    "p-id": 14466
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M628.608 960l-231.232-173.376L628.608 621.44V960zM628.608 852.672v-123.968c0.064 0 272.512 33.024 363.392-148.608-33.024 297.28-363.392 272.576-363.392 272.576z",
    fill: "#89CDF7",
    "p-id": 14467
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIn);
export default __webpack_public_path__ + "static/media/transferIn.f67fbdf5021d5db7a0648c81ef2e8168.svg";
export { ForwardRef as ReactComponent };